import { passwordReset } from '@/js/api/auth.ts';
import { showErrorNotify, showSuccessNotify } from '@/js/notification.ts';

const ERROR_REQUEST_TEXT = 'E-Mail адрес не найден, проверьте и попробуйте еще раз!';
const SUCCESS_REQUEST_TEXT = 'Новый пароль был выслан на Ваш E-Mail.!';
export function initPasswordResetForm(): void {
  const form = document.querySelector<HTMLFormElement>('.js-form-password-reset');
  if (!form)
    return;

  form.addEventListener('submit', handlePasswordResetFormSubmit);

  function handlePasswordResetFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    void passwordResetFormAsync(form);
  }

  async function passwordResetFormAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);

    try {
      const response = await passwordReset(formData);
      if (response.data?.success) {
        showSuccessNotify({ text: SUCCESS_REQUEST_TEXT });
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error: unknown) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
